import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { CargandoProvider } from "./context/cargando-context";
import { SettingsProvider } from "./context/settings-context";
import { EmpresaProvider } from "./context/empresa-context";
import { SnackbarProviderLocal } from "./context/snackbar-provider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <SnackbarProviderLocal>
    <StrictMode>
      <CargandoProvider>
        <SettingsProvider>
          <EmpresaProvider>
            <App />
          </EmpresaProvider>
        </SettingsProvider>
      </CargandoProvider>
    </StrictMode>
  </SnackbarProviderLocal>
);
